import React from 'react';
import AppBar, { AppBarProps } from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/system';
import { Link, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import logo from '../../assets/logo.png';


const NavBar = styled(AppBar)<AppBarProps>(({ theme }) => ({
	backgroundColor: theme.palette.background,
	backgroundImage: 'none',
	boxShadow: 'none',
	borderBottomWidth: 1.5,
	borderBottomStyle: 'solid',
	borderBottomColor: theme.palette.divider,
}));

const AdminNavButton = styled(Button)(({ theme }) => ({
	marginRight: theme.spacing(1.5),
	color: theme.palette.text.disabled,
	textDecoration: 'none',
	borderRadius: 0,
	'&.active': {
		color: theme.palette.text.primary,
	},
	':hover': {
		color: theme.palette.text.secondary,
	},
})) as typeof Button;

const ACTIVECLASSNAME = 'active';
// Team and organization pages live under the Users section of the app.
const USERS_SEGMENTS = ['users', 'teams', 'organizations'];
const INACTIVECLASSNAME = 'MuiButton-root MuiButton-text';

export default function AdminHeader() {
	const { pathname } = useLocation();
	const secondSegment = pathname.split('/')[2] ?? '';
	const { logout } = useAuth0();

	return (
		<NavBar position="static">
			<Toolbar>
				<Box
					component="img"
					sx={{ height: 28, mr: 3 }}
					alt="Logo"
					src={logo}
				/>

				<Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
					<AdminNavButton
						size="large"
						disableRipple
						component={Link}
						to="/admin/users"
						className={USERS_SEGMENTS.includes(secondSegment) ? ACTIVECLASSNAME : INACTIVECLASSNAME}
					>
						Users
					</AdminNavButton>

					<AdminNavButton
						size="large"
						disableRipple
						component={Link}
						to="/admin/tasks"
						className={secondSegment === 'tasks' ? ACTIVECLASSNAME : INACTIVECLASSNAME}
					>
						Tasks
					</AdminNavButton>

					<AdminNavButton
						size="large"
						disableRipple
						component={Link}
						to="/admin/datasets"
						className={secondSegment === 'datasets' ? ACTIVECLASSNAME : INACTIVECLASSNAME}
					>
						Datasets
					</AdminNavButton>

					<AdminNavButton
						size="large"
						disableRipple
						component={Link}
						to="/admin/symbols"
						className={secondSegment === 'symbols' ? ACTIVECLASSNAME : INACTIVECLASSNAME}
					>
						Symbols
					</AdminNavButton>

					<AdminNavButton
						size="large"
						disableRipple
						component={Link}
						to="/admin/periods"
						className={secondSegment === 'periods' ? ACTIVECLASSNAME : INACTIVECLASSNAME}
					>
						Periods
					</AdminNavButton>

				</Box>

				<Box>
					<Button
						size="small"
						variant="outlined"
						color="inherit"
						onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
					>
						Logout
					</Button>
				</Box>
			</Toolbar>
		</NavBar>
	);
}
